module.exports = __webpack_public_path__ + "img/wash.4fc60742.svg";